/* global axios */
import ApiClient from '../ApiClient';

// T-268: onde a operação está errando a tabulação, para virar treinamento.
class RetabulacaoAPI extends ApiClient {
  constructor() {
    super('fandata/retabulacao', { accountScoped: true });
  }

  get({ since, until, inboxId, lado } = {}) {
    return axios.get(this.url, {
      params: { since, until, inbox_id: inboxId, lado },
    });
  }
}

export default new RetabulacaoAPI();
